import { render } from "./OvApprovalModal.vue?vue&type=template&id=37ab1803&scoped=true"
import script from "./OvApprovalModal.vue?vue&type=script&lang=js"
export * from "./OvApprovalModal.vue?vue&type=script&lang=js"

import "./OvApprovalModal.vue?vue&type=style&index=0&id=37ab1803&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ab1803"],['__file',"src/components/OvApprovalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ab1803"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ab1803', __exports__)) {
    api.reload('37ab1803', __exports__)
  }
  
  module.hot.accept("./OvApprovalModal.vue?vue&type=template&id=37ab1803&scoped=true", () => {
    api.rerender('37ab1803', render)
  })

}


export default __exports__